import { render } from "./ConfigurationCard.vue?vue&type=template&id=47d27136&ts=true"
import script from "./ConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./ConfigurationCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__